import auth from '@react-native-firebase/auth';
import { UserServiceClient } from 'fitbeat.api-clients';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonSize } from '../components';
import { FormError } from '../ui/components';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import { TextInput } from '../ui';
import { isEmailValid } from '../utils';
import { createUnauthenticatedUserServiceClient } from '../utils/apiClientFactory';
import { defaultScale } from '../utils/scaling';
import { captureEmailFormSubmitted as captureEmailFormSubmittedAction } from './actions';
import { styles as signupFormStyles } from './SignupFormsStyles';

interface IProps {
  captureEmailLoading: boolean;
  captureEmailFormSubmitted: (
    email: string,
    unAuthenticatedUserServiceClient: UserServiceClient,
    navigate: (route: string) => void,
  ) => void;
  t: (key: string, options?: any) => string;
  navigation: {
    navigate: (route: string) => void;
  };
  captureEmailError: string | undefined;
  handleSubmit: (fn: (values: ICaptureEmailForm) => void) => () => any;
}

interface ICaptureEmailForm {
  email: string;
}

class CaptureEmail extends PureComponent<IProps> {
  private readonly unAuthenticatedUserServiceClient: UserServiceClient;

  constructor(props) {
    super(props);
    this.unAuthenticatedUserServiceClient = createUnauthenticatedUserServiceClient();
  }

  public render() {
    const {
      t,
      handleSubmit,
      captureEmailLoading,
      captureEmailError,
    } = this.props;

    return (
      <View style={signupFormStyles.container}>
        <ScrollView
          scrollEnabled={false}
          keyboardShouldPersistTaps='handled'>

          <Text style={styles.heading}>{t('auth:captureEmailHeadingToContinue')}</Text>
          <Text style={styles.subHeading}>{t('auth:captureEmailSubHeading')}</Text>

          <Field
            forwardRef
            autoFocus
            name='email'
            placeholder={t('formFields:enterEmail')}
            returnKeyType='done'
            autoCapitalize='none'
            component={TextInput}
            validate={isEmailValid}
            keyboardType='email-address'
            onSubmitEditing={handleSubmit(this.onSubmit)}
          />

          {captureEmailError && <FormError error={{message: t(`auth:${captureEmailError}`)}} color={Theme.GREY_DARK} />}
          <Button
            fontColor={Theme.WHITE}
            size={ButtonSize.MEDIUM}
            isLoading={captureEmailLoading}
            containerStyle={{ marginTop: defaultScale(10) }}
            onPress={handleSubmit(this.onSubmit)}
            title={t('auth:continue')}
          />
        </ScrollView>
      </View>
    );
  }

  private onSubmit = async (values: ICaptureEmailForm) => {
    const { captureEmailFormSubmitted, navigation } = this.props;
    captureEmailFormSubmitted(values.email, this.unAuthenticatedUserServiceClient, navigation.navigate);
  }
}

const styles = StyleSheet.create({
  heading: {
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(10),
  },
  subHeading: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
    marginBottom: defaultScale(20),
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    captureEmailFormSubmitted: (email, unAuthenticatedUserServiceClient, navigate) =>
      dispatch(captureEmailFormSubmittedAction(email, unAuthenticatedUserServiceClient, navigate)),
  };
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    captureEmailError: state.auth.signup.captureEmailError,
    captureEmailLoading: state.auth.signup.captureEmailLoading,
  };
};

export const CaptureEmailScreen = translate(['auth', 'formFields'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({ form: 'CaptureEmail' })(CaptureEmail),
  ),
);
